module.exports = __webpack_public_path__ + "static/img/game-TowerOfFantasy_PC.7ea48d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-TowerOfFantasy_PC.jpg
// module id = h3MI
// module chunks = 0